import { render } from "@/share/components/controls/noTextSvgButton/NoTextSVGButton.html?vue&type=template&id=901703a8&scoped=true&external"
import script from "@/share/components/controls/noTextSvgButton/NoTextSVGButton.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/noTextSvgButton/NoTextSVGButton.js?vue&type=script&lang=js&external"

import "@/share/components/controls/noTextSvgButton/NoTextSVGButton.scss?vue&type=style&index=0&id=901703a8&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-901703a8"]])

export default __exports__